// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetContractDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetContractApiClient extends BaseCRUDApiClient<AssetContractDto> {
  baseUrl = this.config.apiEndpoint + '/asset-contract';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  importAssets(assetContracts: Partial<AssetContractDto>[]) {
    return this.http.put<AssetContractDto[]>(
      `${this.baseUrl}/change-contract`,
      assetContracts,
    );
  }
}
